if (!customElements.get('pg-pdp-sticky-cta')) {
  customElements.define('pg-pdp-sticky-cta', class extends HTMLElement {
    connectedCallback() {
      this.mainButton = document.getElementById(this.dataset.sectionId)?.querySelector('[data-pdp2-add-to-cart]');
      this.button = this.querySelector('button');
      if (!this.mainButton || !this.button || this.controller) return;

      this.controller = new AbortController();
      this.mobile = window.matchMedia('(max-width: 989px)');
      this.label = this.button.textContent;
      this.lowerButton = document.querySelector('.pg-bundle-ssp__cta');
      const options = { signal: this.controller.signal };
      const update = () => {
        this.frame = null;
        const lower = this.lowerButton?.getBoundingClientRect();
        const lowerVisible = lower && lower.bottom > 0 && lower.top < window.innerHeight;
        this.hidden = !this.mobile.matches || this.mainButton.getBoundingClientRect().bottom > 0 ||
          Boolean(lowerVisible) || document.documentElement.hasAttribute('data-scroll-locked');
        this.button.disabled = this.mainButton.disabled;
        this.button.textContent = this.mainButton.disabled ? this.mainButton.textContent : this.label;
        document.body.classList.toggle('pg-pdp2-sticky-active', !this.hidden);
        if (!this.hidden) {
          document.body.style.setProperty('--pg-pdp2-sticky-space', `${this.getBoundingClientRect().height}px`);
        }
      };
      this.schedule = () => {
        if (this.frame == null) this.frame = requestAnimationFrame(update);
      };
      this.button.addEventListener('click', () => {
        if (!this.mainButton.disabled) this.mainButton.click();
      }, options);
      window.addEventListener('scroll', this.schedule, { ...options, passive: true });
      window.addEventListener('resize', this.schedule, options);
      this.mobile.addEventListener('change', this.schedule, options);
      this.buttonObserver = new MutationObserver(this.schedule);
      this.buttonObserver.observe(this.mainButton, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
      this.lockObserver = new MutationObserver(this.schedule);
      this.lockObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-scroll-locked'] });
      update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.buttonObserver?.disconnect();
      this.lockObserver?.disconnect();
      if (this.frame != null) cancelAnimationFrame(this.frame);
      document.body.classList.remove('pg-pdp2-sticky-active');
      document.body.style.removeProperty('--pg-pdp2-sticky-space');
    }
  });
}
